import ContactChatBox from '@moncler/components/contacts/ContactChatBox';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ContactPhoneBox from '@moncler/components/contacts/ContactPhoneBox';
import InstantMessageBox from '@moncler/components/contacts/InstantMessageBox';
import ContactUsForm from './ContactUsForm';
import { contactFormId } from '@utils/constants';
import customEventBus from '@common/scripts/libs/eventBus';
const ContactUs = (props) => {
    const { t } = useTranslation();
    const scrollToAnchor = () => {
        if (window.location.hash === `#${contactFormId}`) {
            const contactForm = document.getElementById(contactFormId);
            contactForm && contactForm.scrollIntoView();
        }
    };
    useEffect(() => {
        window.addEventListener('load', scrollToAnchor);
        customEventBus.on('contacts:selected-country', scrollToAnchor);
        return () => {
            window.removeEventListener('load', scrollToAnchor);
        };
    }, []);
    return (React.createElement("div", { className: "contact-us" },
        React.createElement(ContactUsForm, { mbmReasonActive: props.mbmReasonActive, giftCardActive: props.giftCardActive }),
        !props.removeContactMethods && (React.createElement("div", { className: "contact-us__other" },
            (window.instantmessage || window.contactphone || (!window.appmode && window.chatenabled)) && (React.createElement("h2", { className: "contact-us__title" }, t('contactus.talktoaclientadvisor'))),
            window.instantmessage && (React.createElement(InstantMessageBox, { type: "box", instantMessage: window.instantmessage, instantMessageNumber: window.instantMessageNumber, instantMessageRegion: window.instantMessageRegion })),
            window.instantmessage2 && (React.createElement(InstantMessageBox, { type: "box", instantMessage: window.instantmessage2, instantMessageNumber: window.instantMessageNumber2, instantMessageRegion: window.instantMessageRegion })),
            window.contactphone && React.createElement(ContactPhoneBox, { type: "box" }),
            !window.appmode && React.createElement(ContactChatBox, { type: "box" })))));
};
export default ContactUs;
